import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Toast, ListView, Picker, List } from 'antd-mobile';
import Http from '../../config/axiosUtils';
import Empty from '../../components/common/Empty';
import IncomeFilter from '../../components/income/IncomeFilter';

import '../../assets/scss/Custom/customList.scss';
import '../../assets/scss/Income/incomeDetail.scss';

class CustomList extends Component {
  constructor() {
    super();
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2,
    });
    this.state = {
      dataSource: dataSource, //列表初始化
      isLoading: true, //是否加载中
      initData: [], //总数据
      postData: {
        pageNumber: 1, //当前页数
        pageSize: 9, //每页个数
        incomeType: '',
        incomeSourceType: ''
      },
      totalPage: 0, //总页数
      preArray: [],
      dateList: [], //日期列表
      sourceList: [], //收益来源列表
      typeList: [], //收益类型列表
      incomeDate: '', //当前日期
      incomeSourceType: null, //收益来源
      incomeType: '', //收益类型
      emptyData: false,
      isHasData: false,
      isShowFilter: false, //筛选
      defaultFilter: {}, //筛选默认值
      firstDate: '',
    }
  }

  //触底加载
  onEndReached = () => {
    if (!this.state.isLoading) {
      return;
    }
    const postData = this.state.postData;
    postData.pageNumber++;
    this.setState({
      isLoading: true,
      postData: postData
    });
    setTimeout(() => {
      this.fetchData()
    }, 600);
  }

  //初始化
  componentDidMount() {
    this.fetchDate();
    this.fetchSource();
    this.fetchType();
    this.fetchData();
  }

  fetchData = async () => {
    const path = '/spread/web/income/detail';
    const res = await Http.post(path, this.state.postData);
    if (res.code === 0) {
      if (!res.data.content.length) {
        this.setState({
          emptyData: true,
          initData: [],
        });
        return;
      }
      const list = res.data.content;
      const result = [];
      let n = 0;
      let next;
      const pre = list[this.state.postData.pageSize - 1] && list[this.state.postData.pageSize - 1].incomeDate;
      if (pre) {
        this.state.preArray.push(pre);
      }
      if (this.state.postData.pageNumber === 1) {
        this.setState({
          firstDate: list[0].incomeDate
        })
      }
      if (this.state.postData.pageNumber > 1) {
        next = list[0] && list[0].incomeDate;
        if (this.state.preArray[this.state.postData.pageNumber - 2] === next) {
          list[0].isFirst = true;
        }
      }
      for (let i = 0; i < list.length; i++) {
        if ((list[i] && list[i].incomeDate) !== (list[i + 1] && list[i + 1].incomeDate)) {
          result.push(list.slice(n, i + 1));
          n = i + 1;
        }
      }
      this.state.initData = this.state.initData.concat([result]);
      this.setState({
        initData: this.state.initData,
        dataSource: this.state.dataSource.cloneWithRows(this.state.initData),
        isLoading: true,
        postData: this.state.postData,
        preArray: this.state.preArray,
        emptyData: false
      });
      if (this.state.postData.pageNumber === res.data.totalPages || res.data.totalPages === 0) {
        this.setState({
          isLoading: false
        });
      }
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //日期
  fetchDate = async () => {
    const path = '/spread/web/income/incomeDateList';
    const res = await Http.get(path);
    if (res.code === 0) {
      const newArr = res.data.map(a => {
        let arr = [];
        arr.push({label: a, value: a});
        return arr[0];
      });
      newArr.unshift({label: '全部', value: ''});
      this.setState({
        dateList: newArr,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //来源
  fetchSource = async () => {
    const path = '/spread/web/income/incomeSourceTypeList';
    const res = await Http.get(path);
    if (res.code === 0) {
      const arr = this.filterPicker(res.data);
      this.setState({
        sourceList: arr,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  filterPicker = (data) => {
    data && data.map(a => {
      let arr = [];
      arr.push({label: a.value, value: a.code});
      return arr[0];
    });
  }

  //类型
  fetchType = async () => {
    const path = '/spread/web/income/incomeTypeList';
    const res = await Http.get(path);
    if (res.code === 0) {
      const arr = this.filterPicker(res.data);
      this.setState({
        typeList: arr,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //选择日期
  onChangeDate = (val) => {
    const postData = this.state.postData;
    postData.pageNumber = 1;
    postData.incomeDate = val[0];
    this.setState({
      initData: [],
      postData: postData,
      isHasData: true,
      incomeDate: val,
      firstDate: val
    }, () => {
      this.fetchData();
    })
  }

  //类型筛选
  onChangeType = (type) => {
    const postData = this.state.postData;
    postData.pageNumber = 1;
    postData.nodeCode = type[0];
    this.setState({
      initData: [],
      postData: postData,
      isHasData: true
    }, () => {
      this.fetchData();
    })
  }

  //关闭筛选
  closeFilter = () => {
    this.setState({
      isShowFilter: false
    })
  }

  //筛选确定
  filterConfirm = (type, source) => {
    const obj = this.state.postData;
    obj.incomeType = type;
    obj.incomeSourceType = source;
    obj.pageNumber = 1;
    this.setState({
      isShowFilter: false,
      initData: [],
      postData: obj,
      isHasData: true
    }, () => {
      this.fetchData();
    });
  }

  render () {
    const row = (rowData, sectionID, rowID) => {
      return (
        <div className='custom-list incomeDetail'>
          <ul className='list'>
            {
              rowData.map((item, index) => {
                return (
                  <div key={index}>
                    <div className='list-wrap'>
                    {(this.state.postData.pageNumber === 1 || !item[0].isFirst) &&
                      <div className='list-date'>
                        <div>
                          {item[0].incomeDate} <i className='iconfont icon-arrrow'></i>
                          <div className='common-pick list-date-pick'>
                            <Picker
                              data={this.state.dateList}
                              value={this.state.incomeDate}
                              cols={1}
                              onChange={this.onChangeDate}
                            >
                              <List.Item arrow="horizontal"></List.Item>
                            </Picker>
                          </div>
                        </div>
                        {item[0].incomeDate === this.state.firstDate && <div onClick={() => this.setState({ isShowFilter: true })}>筛选 <i className='iconfont icon-arrrow'></i></div>}
                      </div>}
                    </div>
                    <ul>
                      {
                        item.map((item1, index1) => {
                          return (
                            <li key={index1}>
                              <div className='list-left'>
                                <div>
                                  {item1.name || '未实名'}
                                  <span>{item1.incomeSourceType}</span>
                                  <span>{item1.incomeType}</span>
                                </div>
                                <div className='left-bottom'>{item1.mobile}</div>
                              </div>
                              <div className='list-right'>
                                <div className='list-right-income'>
                                  <div>{item1.amount}</div>
                                  <div>{item1.incomeTime}</div>
                                </div>
                              </div>
                            </li>
                          )
                        })
                      }
                    </ul>
                  </div>
                )
              })
            }
          </ul>
        </div>
      );
    };

    return (
      <div>
        <Helmet><title>收益明细</title></Helmet>
        <div>
        {
          this.state.emptyData ? <div>{this.state.isHasData && <div className='list-date'>
            <div>
              {this.state.firstDate} <i className='iconfont icon-arrrow'></i>
              <div className='common-pick list-date-pick'>
                <Picker
                  data={this.state.dateList}
                  value={this.state.incomeDate}
                  cols={1}
                  onChange={this.onChangeDate}
                >
                  <List.Item arrow="horizontal"></List.Item>
                </Picker>
              </div>
            </div>
            <div onClick={() => this.setState({ isShowFilter: true })}>筛选 <i className='iconfont icon-arrrow'></i></div>
          </div>}<div style={{paddingTop: '0.5rem'}}><Empty tip='暂无数据...' /></div></div> : <div><ListView
            ref={el => this.lv = el}
            dataSource={this.state.dataSource}
            renderFooter={() =>
              (<div style={{ textAlign: 'center', marginTop: '0.1rem' }}>
                {this.state.isLoading ? '加载中...' : '已加载全部~'}
              </div>)}
            renderRow={row}
            style={{height: '13.34rem', overflow: 'auto'}}
            onEndReached={this.onEndReached}
            onEndReachedThreshold={10}
          />
          </div>
          }
        </div>
        {this.state.isShowFilter && <IncomeFilter defaultFilter={this.state.postData} closeFilter={this.closeFilter} filterConfirm={this.filterConfirm}></IncomeFilter>}
      </div>
    )
  }
}

export default CustomList;
